import {observer} from "mobx-react"
import React, {Component} from "react"
import PropTypes from "prop-types"
import {Table} from "semantic-ui-react"
import Price from "components/Price/Price"
import _ from "lodash"

@observer
export default class ProductTableReadOnly extends Component {
	static propTypes = {
		list    : PropTypes.object,
		cart    : PropTypes.object,
		onChange: PropTypes.func,
		products: PropTypes.array,
		minimal : PropTypes.bool
	}

	constructor() {
		super()
	}

	render() {
		let {list, cart, products, onChange, minimal, showTax} = this.props
		let positions = list || products
		if ( list ) positions = list.products
		let rows = _.map( positions, ( product, index ) => {
			return (
				<ProductRow showTax={showTax} minimal={minimal} key={index} index={index} onChange={onChange} list={list} cart={cart} product={product} />
			)
		} )
		return (
			<Table>
				<colgroup>
					<col width="30%" />
					<col width="" />
					<col width="15%"/>
					<col width="10%" />
					<col width="10%" />
					<col width="10%" />
				</colgroup>
				<thead>
				<tr>
					<th>{translate("Artikel")}</th>
					<th>{translate( "deliverable" )}</th>
					{!minimal && <th>{translate("Brutto EK pro VE")}</th>}
					<th>{translate( "KE pro VE" )}</th>
					<th>{translate( "Menge in (VE)" )}</th>
					{showTax && <th>{translate( "Steuer" )}</th>}
					<th className="tr">
						<div className="tr">{translate( "Summe" )}</div>
					</th>
				</tr>
				</thead>
				<tbody>
				{rows}
				</tbody>
			</Table>
		)
	}
}

const ProductRow = ( {product, minimal, showTax} ) => {
	return (
		<tr>
			<td>
				<strong>{product.article_nr}</strong>
				<div><span className="product-title"><span className="nowrap">{product.title}</span></span></div>
			</td>
			<td>
				<span>{product.getNotice( "tiny" )}</span>
			</td>
			{!minimal && <td>
        <Price>{product.price}</Price>
        <div className="flex flex-row">
          {product.pinfos.gc_rabatt && <a title={translate( "Coupon-Rabatt" )} className="labelNeu1">&nbsp;&nbsp;{translate("Coupon:")} {product.pinfos.gc_rabatt} %&nbsp;&nbsp;</a>}
          {product.isSale && product.pinfos.sale_percent && <a className="labelNeu1">&nbsp;&nbsp;{translate("Sale!")}&nbsp;&nbsp;</a>}
        </div>
      </td>}
			<td>
				<div className={"nowrap"}>{product.extras.veInhalt && product.extras.veInhalt.value.value ? product.extras.veInhalt.value.value : "1"} {translate("KE")}</div>
			</td>
			<td>
				<div className={"nowrap"}>{product.count} {translate( "VE" )}</div>
			</td>
			{showTax && <td>
				<div><Price>{product.price * product.count * product.unit_multi * product.taxRate}</Price></div>
				<div className={"black-60"}>{product.taxRate * 100} %</div>
			</td>}
			<td className="tr">
				<div className="tr"><Price>{product.price * product.count * product.unit_multi}</Price></div>
			</td>
		</tr>
	)
}

ProductRow.propTypes = {
	index   : PropTypes.any,
	list    : PropTypes.object,
	cart    : PropTypes.object,
	onChange: PropTypes.func,
	product : PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/theme/lindtbShop/components/Product/ProductTableReadOnly.js